// extracted by mini-css-extract-plugin
export default {"title":"RegFormsTitle_title__J+OkX"};